import { availableLanguages } from '../models/available-languages.const';
import { TranslationScope } from '../models/translation-scope.type';

export type TranslationState = {
  _loadedScopes: Set<TranslationScope>;
  _translations: Map<string, string>;
  availableLanguages: string[];
  currentLanguage: string;
};

export const initialState: TranslationState = {
  _loadedScopes: new Set(),
  _translations: new Map(),
  availableLanguages,
  currentLanguage: 'en',
};
